<template>
  <div class="fixed-nav d-flex justify-content-between bg-dark py-3 px-4 padding-0">
    <slot name="left">
      <span v-if="leftOption === 'back-dashboard'" class="d-flex align-items-center">
        <router-link :to="ROUTE_DASHBOARD" class="d-inline-block d-lg-none"><FontAwesomeIcon class='text-white' icon="chevron-left" /></router-link>
        <a href="#" class="d-none d-lg-inline-block text-primary" @click.prevent="toggleSidebar"><FontAwesomeIcon icon="bars" /></a>
      </span>
      <span v-if="leftOption === 'back'" class="d-flex align-items-center">
        <a href="#" v-on:click="back($event)" class="d-inline-block d-lg-none"><FontAwesomeIcon class='text-white' icon="chevron-left" /></a>
        <a href="#" class="d-none d-lg-inline-block text-primary" @click.prevent="toggleSidebar"><FontAwesomeIcon icon="bars" /></a>
      </span>
      <span v-if="leftOption === 'menu'" class='text-primary'>
        <!-- Mobile: navigate to menu page -->
        <router-link :to="ROUTE_MENU" class="d-inline-block d-lg-none"><FontAwesomeIcon icon="list" /></router-link>
        <!-- Desktop: toggle sidebar -->
        <a href="#" class="d-none d-lg-inline-block text-primary" @click.prevent="toggleSidebar"><FontAwesomeIcon icon="bars" /></a>
      </span>
    </slot>
    <span v-if="title != null" class="text-white top-nav-title">{{ title }}</span>
    <span v-else class="text-white top-nav-title">{{ hasMultipleBoxes ? currentBoxName : (userProvider ? userProvider.name : 'MUSICBOX') }}</span>
    <slot name="right">
      <a href="#">&nbsp;</a>
    </slot>
  </div>
</template>

<script>
import { ROUTE_MENU, ROUTE_BOXES, ROUTE_DASHBOARD } from '@/const/routeNames'
export default {

  name: 'TopMenu',

  props: {
    backOverwrite: Function,
    title: String,
    left: { default: 'back' },
    mid: {},
    right: { default: 'none' },
    leftOption: { default: 'back' }
  },

  data () {
    return {
      ROUTE_BOXES,
      ROUTE_MENU,
      ROUTE_DASHBOARD
    }
  },

  computed: {
    userProvider () {
      return this.$store.state.auth.userProvider
    },
    currentBoxName () {
      return this.$store.state.audio.currentBox ? this.$store.state.audio.currentBox.name : ''
    },
    hasMultipleBoxes () {
      return this.$store.state.audio.allBoxes != null && this.$store.state.audio.allBoxes.length > 1
    }
  },

  methods: {
    back (e) {
      e.preventDefault()
      if (this.backOverwrite) {
        this.backOverwrite()
      } else {
        this.$router.back()
      }
    },
    toggleSidebar () {
      this.$store.commit('toggleSidebar')
    }
  }
}
</script>

<style scoped>
.sidebar-toggle-btn {
  margin-left: 12px;
  padding: 0 4px;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/TopMenu.vue